<template>
    <div class="bg">
        <div v-if="source" id="overview" class="main">
            <div class="flex flex-col">
                <h1 class="title">{{ source.title }}</h1>
                <div class="space-y-6 pt-8 font-medium text-[#333] max-lg:px-2">
                    <p v-for="item in source.desc" :key="item" v-html="item"></p>
                </div>
                <div class="flex items-center space-x-4 pt-20 max-lg:justify-center">
                    <span class="dasiy-btn dasiy-btn-primary rounded-full" @click="showDialog">{{ source.fullCompare }}</span>
                    <a :href="source.link" class="dasiy-btn-white dasiy-btn dasiy-btn-primary rounded-full !text-primary">{{ source.explore }}</a>
                </div>
            </div>
            <ProductSplider :cover="true" :source="source.splides"></ProductSplider>
        </div>
        <!-- <div v-if="show" id="CompareDialog" class="bottom-1/2 right-1/2 z-30 hidden translate-x-1/2 translate-y-1/2 opacity-0"> -->
        <CompareDialog v-if="show" :source="source.dialog" @close="hideDialog"></CompareDialog>
        <!-- </div> -->
    </div>
</template>
<script setup lang="ts">
import ProductSplider from "@/components/ProductView/ProductSplider.vue";
import CompareDialog from "./CompareDialog.vue";
import { gsap } from "gsap";
const props = defineProps<{ source: any }>();
const show = ref(false);
const dialog = ref();

const showDialog = () => {
    show.value = true;
    // dialog.value = document.getElementById("CompareDialog");
    // gsap.to(dialog.value, { display: "block", opacity: 1, duration: 0.5 });
};

const hideDialog = () => {
    show.value = false;
    // dialog.value = document.getElementById("CompareDialog");
    // gsap.to(dialog.value, { display: "none", opacity: 0, y: 0, duration: 0.5 });
};
</script>
<style lang="scss" scoped>
.bg {
    background: linear-gradient(-10.65deg, rgba(255, 255, 255, 0) 60.38%, rgba(255, 49, 228, 0) 54.58%, rgba(255, 49, 228, 0.1) 84.59%);
}
.main {
    @apply mx-auto flex grid-cols-2 flex-col gap-20 pt-20 max-lg:text-center lg:grid lg:max-w-[1024px] xl:max-w-[1100px];

    .title {
        @apply whitespace-pre text-3xl font-semibold  text-[#333] lg:text-5xl lg:leading-snug;
    }
}
</style>
